<template>
  <div class="bg">
    <div class="ad_login">
      <div class="ad_area">
        <div class="ad_title">管理员登录</div>
        <div class="ad_form">
          <el-form label-position="top" :model="form" :rules="rules" ref="form">
            <el-form-item label prop="username">
              <el-input
                v-model="form.username"
                clearable
                prefix-icon="el-icon-s-custom"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
            <el-form-item label prop="password">
              <el-input
                v-model="form.password"
                prefix-icon="el-icon-s-goods"
                placeholder="请输入密码"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label :required="true" :error="verifyError">
              <Verify
                @success="slideSuccess"
                :type="3"
                :showButton="false"
                :barSize="{width:'360px',height:'40px'}"
              ></Verify>
            </el-form-item>
            <el-form-item style="text-align:center;">
              <el-button type="primary" @click="submitForm('form')">立即登录</el-button>
              <el-button @click="resetForm('form')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { login } from "../../api/login";
import Verify from "vue2-verify";
export default {
  name: "login",
  components: {
    Verify
  },
  data() {
    return {
      form: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      isVerify: false,
      verifyError: ""
    };
  },
  methods: {
    slideSuccess() {
      this.isVerify = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.isVerify) {
            this.verifyError = "请先滑动滑块验证";
          } else {
            this.$router.push({ name: "index" });
            // login(this.form).then(res => {
            //   console.log(res);
            // });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.verifyError = "";
    }
  }
};
</script>

<style scoped>
.bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background: url(../../assets/images/login_bg.jpg) no-repeat center center;
  background-size: 100% 100%;
}
.ad_login {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 400px;
  height: 320px;
  margin: auto;
  background-color: #ffffff;
  border-radius: 10px;
}

.ad_area {
  width: 90%;
  margin: 0 auto;
}

.ad_title {
  border-bottom: 1px solid #eeeeee;
  margin: 0 auto;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  text-align: center;
  margin-bottom: 10px;
}
</style>